import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import CompanyProfileInvitation from '@app/model/company_profile_invitation/CompanyProfileInvitation';
import {
	ACCEPT_COMPANY_PROFILE_INVITATION_MUTATION,
	CREATE_COMPANY_PROFILE_INVITATION_MUTATION,
	DISABLE_COMPANY_PROFILE_INVITATION_MUTATION,
	ENABLE_COMPANY_PROFILE_INVITATION_MUTATION,
	FIND_ACTIVE_COMPANY_PROFILE_INVITATION_BY_KEY_QUERY,
	FIND_COMPANY_PROFILE_INVITATION_QUERY,
	RESEND_COMPANY_PROFILE_INVITATION_MUTATION,
} from '@app/model/company_profile_invitation/service/CompanyProfileInvitationGraphQLQueries';
import CompanyProfileInput from '@app/model/company_profile/input/CompanyProfileInput';
import AcceptCompanyProfileInvitationInput
	from '@app/model/company_profile_invitation/input/AcceptCompanyProfileInvitationInput';
import Return from '@app/model/_common/Return';


class CompanyProfileInvitationService {

	public static findCompanyProfileInvitation(profileId: number) {
		return GraphQLExecutor.execute<CompanyProfileInvitation>(FIND_COMPANY_PROFILE_INVITATION_QUERY, { profileId });
	}

	public static findActiveCompanyProfileInvitationByKey(key: string) {
		return GraphQLExecutor.execute<CompanyProfileInvitation>(FIND_ACTIVE_COMPANY_PROFILE_INVITATION_BY_KEY_QUERY, { key });
	}

	public static createCompanyProfileInvitation(input: CompanyProfileInput) {
		return GraphQLExecutor.execute<CompanyProfileInvitation>(CREATE_COMPANY_PROFILE_INVITATION_MUTATION, { input });
	}

	public static acceptCompanyProfileInvitation(input: AcceptCompanyProfileInvitationInput) {
		return GraphQLExecutor.execute<CompanyProfileInvitation>(ACCEPT_COMPANY_PROFILE_INVITATION_MUTATION, { input });
	}

	public static enableCompanyProfileInvitation(profileId: number) {
		return GraphQLExecutor.execute<CompanyProfileInvitation>(ENABLE_COMPANY_PROFILE_INVITATION_MUTATION, { profileId });
	}

	public static disableCompanyProfileInvitation(profileId: number) {
		return GraphQLExecutor.execute<CompanyProfileInvitation>(DISABLE_COMPANY_PROFILE_INVITATION_MUTATION, { profileId });
	}

	public static resendCompanyProfileInvitation(profileId: number) {
		return GraphQLExecutor.execute<Return>(RESEND_COMPANY_PROFILE_INVITATION_MUTATION, { profileId });
	}
}

export default CompanyProfileInvitationService;